import axios from 'axios';

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api'
});

API.interceptors.request.use((config) => {
    const token = localStorage.getItem('numToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

API.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401 && !err.config?.url?.includes('/auth/login')) {
            localStorage.removeItem('numToken');
            localStorage.removeItem('numUser');
            window.location.href = '/login';
        }
        return Promise.reject(err);
    }
);

export default API;
